import tw from "tailwind-styled-components";

const EmptyResult = tw.div`
bg-sky-100
text-sky-700
p-4
rounded-md 
mt-3
`;

export default EmptyResult;
